// @flow
import React from 'react'
import type { Node, ComponentType } from 'react'
import { checkValidity } from '../../utils/validations.js/validation'
import OneNumber from './OneNumber/Regular/Regular'
import TwoNumbers from './TwoNumbers/Regular/Regular'

type CheckBarType = {
  type: string,
  fields: Array<Object>
}

export const CheckedBar = (props: CheckBarType): Node | null => {
  const { type, fields } = props

  const isValid = checkValidity(type, fields)
  if (!isValid) return null

  const RtnBar = getBarOfType(type)
  return RtnBar ? <RtnBar {...props} /> : null
}

export const getBarOfType = (type: string): ComponentType<any> | null => {
  if (!type) return null
  switch (type) {
    case 'TWO_NUMBERS':
      return TwoNumbers
    case 'ONE_NUMBER':
      return OneNumber
    default:
      return null
  }
}

export default CheckedBar



// WEBPACK FOOTER //
// ./src/shared/components/Bars/index.js